import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrivateSpaceRoutingModule } from './private-space-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterModule } from '../shared/components/footer/footer.module';
import { HeaderModule } from '../shared/components/header/header.module';
import { PrivateSpaceComponent } from './private-space.component';
import { MatToolbarModule } from '@angular/material/toolbar'; 
import { MatButtonModule } from '@angular/material/button'; 
import { MatSidenavModule } from '@angular/material/sidenav'; 
import { MatIconModule } from '@angular/material/icon'; 
import { MatCardModule } from '@angular/material/card'

import { MediaMatcher } from '@angular/cdk/layout';
import { ValuationsComponent } from './valuations/valuations.component';
import { SporsorshipsComponent } from './sporsorships/sporsorships.component';
import { ViewPropertiesComponent } from './properties/view-properties/view-properties.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddPropertyComponent } from './properties/add-property/add-property.component';
import { AddSponsorshipRequestsComponent } from './sponsorship-requests/add-sponsorship-requests/add-sponsorship-requests.component';
import { ViewSponsorshipRequestsComponent } from './sponsorship-requests/view-sponsorship-requests/view-sponsorship-requests.component';
import { AddValuationRequestsComponent } from './valuation-requests/add-valuation-requests/add-valuation-requests.component';
import { ViewValuationRequestsComponent } from './valuation-requests/view-valuation-requests/view-valuation-requests.component';
import { EditPropertyComponent } from './properties/edit-property/edit-property.component';
import { ViewSinglePropertyComponent } from './properties/view-single-property/view-single-property.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmComponent } from './components/dialog/confirm/confirm.component';
import { EditSponsorshipRequestComponent } from './sponsorship-requests/edit-sponsorship-request/edit-sponsorship-request.component';
import { ViewSingleSponsorshipRequestComponent } from './sponsorship-requests/view-single-sponsorship-request/view-single-sponsorship-request.component';
import { EditValuationRequestComponent } from './valuation-requests/edit-valuation-request/edit-valuation-request.component';
import { ViewSingleValuationRequestComponent } from './valuation-requests/view-single-valuation-request/view-single-valuation-request.component';

@NgModule({
  declarations: [
    PrivateSpaceComponent,
    ValuationsComponent,
    SporsorshipsComponent,
    ViewPropertiesComponent,
    DashboardComponent,
    AddPropertyComponent,
    AddSponsorshipRequestsComponent,
    ViewSponsorshipRequestsComponent,
    AddValuationRequestsComponent,
    ViewValuationRequestsComponent,
    EditPropertyComponent,
    ViewSinglePropertyComponent,
    ConfirmComponent,
    EditSponsorshipRequestComponent,
    ViewSingleSponsorshipRequestComponent,
    EditValuationRequestComponent,
    ViewSingleValuationRequestComponent
  ],
  imports: [
    CommonModule,
    PrivateSpaceRoutingModule, 
    FormsModule, 
    ReactiveFormsModule, 
    FooterModule, 
    HeaderModule,
    MatToolbarModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule
  ],
  providers: [MediaMatcher],
})
export class PrivateSpaceModule { 

  
}
